import React, { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, BookMarked } from "lucide-react";
import { toast } from "sonner";
import { capacitacionAdminApi, apiError } from "../../lib/api";
import { ModuleEditor, emptyCap } from "../../components/admin/capacitaciones/ModuleEditor";
import { ProgressTab } from "../../components/admin/capacitaciones/ProgressTab";
import { PublicTab } from "../../components/admin/capacitaciones/PublicTab";
import { CapIcon } from "../../components/capacitaciones/CapIcon";

const TABS = [["modulos", "Módulos"], ["progreso", "Progreso de usuarios"], ["publico", "Link público y recordatorios"]];

const ModulesTab = ({ items, programas, reload }) => {
  const [edit, setEdit] = useState(null);
  const remove = async (c) => {
    if (!window.confirm(`¿Eliminar «${c.titulo}»?`)) return;
    try { await capacitacionAdminApi.remove(c.id); toast.success("Eliminado."); reload(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="cap-modules-tab">
      <button data-testid="cap-new-module" onClick={() => setEdit(emptyCap(Math.max(0, ...items.map((c) => c.orden || 0)) + 1))} className="inline-flex items-center gap-2 rounded-xl bg-[var(--gold)] text-[#0A1C30] font-extrabold px-4 py-2.5 text-sm"><Plus className="w-4 h-4" /> Nuevo módulo</button>
      <div className="mt-4 grid md:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.map((c) => (
          <div key={c.id} data-testid={`cap-admin-card-${c.id}`} className={`rounded-2xl ring-1 ring-black/5 p-4 bg-white ${c.publicado ? "" : "opacity-60"}`}>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-xl bg-[#0A1C30] flex items-center justify-center"><CapIcon name={c.icono} className="w-5 h-5 text-[var(--gold)]" /></span>
              <div className="flex-1 min-w-0"><div className="text-[10px] font-extrabold text-[#B99B2E] tracking-widest">MÓDULO {c.orden}</div><div className="font-extrabold text-[#0A1C30] truncate">{c.titulo}</div></div>
              <button data-testid={`cap-edit-${c.id}`} onClick={() => setEdit(c)} className="p-1.5 rounded-lg hover:bg-[#F1F3F7]"><Pencil className="w-4 h-4" /></button>
              <button data-testid={`cap-del-${c.id}`} onClick={() => remove(c)} className="p-1.5 rounded-lg hover:bg-[#FDECEC] text-[#C0392B]"><Trash2 className="w-4 h-4" /></button>
            </div>
            <div className="mt-3 text-xs text-[#6B7688]">{c.subsecciones?.length || 0} subsecciones · {c.preguntas?.length || 0} preguntas · {c.programas?.length ? c.programas.join(", ") : "Todos los programas"}</div>
          </div>
        ))}
      </div>
      {edit && <ModuleEditor value={edit} programas={programas} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); reload(); }} />}
    </div>
  );
};

export default function CapacitacionesAdmin() {
  const [tab, setTab] = useState("modulos");
  const [data, setData] = useState({ items: [], programas: [] });
  const load = () => capacitacionAdminApi.list().then(setData).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="capacitaciones-admin">
      <h1 className="text-2xl font-extrabold text-[#0A1C30] flex items-center gap-2"><BookMarked className="w-6 h-6 text-[#E9A400]" /> Capacitaciones</h1>
      <p className="text-sm text-[#6B7688] mt-1">Onboarding obligatorio: los nuevos candidatos y padres/madres no pueden usar la app hasta aprobar todos sus módulos (4/5).</p>
      <div className="mt-6 flex gap-2 flex-wrap">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`cap-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-2 rounded-xl text-sm font-bold transition-colors ${tab === k ? "bg-[#0A1C30] text-white" : "bg-white ring-1 ring-black/5 text-[#4A5568]"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-6">
        {tab === "modulos" && <ModulesTab items={data.items} programas={data.programas} reload={load} />}
        {tab === "progreso" && <ProgressTab programas={data.programas} />}
        {tab === "publico" && <PublicTab />}
      </div>
    </div>
  );
}
